import { Link, useNavigate } from 'react-router-dom'
import { useOrdersList } from '../lib/useOrdersList'
import { FlagStrip } from '../components/FlagStrip'
import { STATUS_LABELS } from '../types'

export default function DesignPage() {
  const { orders, loading, search, setSearch, page, setPage, totalPages } = useOrdersList({ fixedStatus: 'design' })
  const navigate = useNavigate()

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Design</h1>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input
          type="search"
          placeholder="Referenz, Kunde suchen…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1) }}
          style={{ width: 300 }}
        />
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
          <div className="loading">Aufträge werden geladen…</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Referenz</th>
                <th>Kunde</th>
                <th>Flaggen</th>
                {/* Design-specific columns go here */}
                <th>Status</th>
                <th>Aktualisiert</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--color-muted)' }}>Keine Aufträge gefunden</td></tr>
              )}
              {orders.map((o) => (
                <tr
                  key={o.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/orders/${o.id}`)}
                >
                  <td><Link to={`/orders/${o.id}`} onClick={(e) => e.stopPropagation()}>{o.reference}</Link></td>
                  <td>{o.client_name}<br /><small style={{ color: 'var(--color-muted)' }}>{o.client_email}</small></td>
                  <td><FlagStrip flags={o.flags} /></td>
                  {/* Design-specific cells go here */}
                  <td><span className={`badge badge-${o.status}`}>{STATUS_LABELS[o.status]}</span></td>
                  <td>{new Date(o.updated_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
          <button className="btn btn-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Zurück</button>
          <span style={{ alignSelf: 'center', color: 'var(--color-muted)' }}>Seite {page} / {totalPages}</span>
          <button className="btn btn-secondary" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Weiter →</button>
        </div>
      )}
    </div>
  )
}
